export const communityKeys = {
  state: (locationId: string) => ['community', 'state', locationId] as const,
  picks: (locationId: string) => ['community', 'picks', locationId] as const,
  network: (locationId: string) => ['community', 'network', locationId] as const,
  /** Prefix of every partner detail for a location, for invalidation. */
  partners: (locationId: string) => ['community', 'partner', locationId] as const,
  partner: (locationId: string, partnerId: string) =>
    ['community', 'partner', locationId, partnerId] as const,
  /** Prefixes for invalidating every month / partner of a location. */
  referralsAll: (locationId: string) => ['community', 'referrals', locationId] as const,
  cadenceAll: (locationId: string) => ['community', 'cadence', locationId] as const,
  referralRows: (locationId: string, month: string) =>
    ['community', 'referrals', locationId, month] as const,
  cadence: (locationId: string, partnerId: string) =>
    ['community', 'cadence', locationId, partnerId] as const,
};
